import { 
    FETCH_NOTIFICATIONS,
    FETCH_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS_FAILED,
    FETCH_SCHEDULED_NOTIFICATIONS,
    FETCH_SCHEDULED_NOTIFICATIONS_SUCCESS,
    FETCH_SCHEDULED_NOTIFICATIONS_FAILED,
    FETCH_CAMPAIGNS,
    FETCH_CAMPAIGNS_SUCCESS,
    FETCH_CAMPAIGNS_FAILED,
  } from "../store/types";
  
  export const INITIAL_STATE = {
    notifications: null,
    scheduled: null,
    // Bulk-delivery campaigns. Separate `campaignsLoading` so a live delivery
    // stream never flips the shared `loading` flag and blanks the other tabs.
    campaigns: null,
    campaignsLoading: false,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const notificationreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_NOTIFICATIONS:
        return {
          ...state,
          loading:true
        };
      case FETCH_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          notifications:action.payload,
          loading:false
        };
      case FETCH_NOTIFICATIONS_FAILED:
        return {
          ...state,
          notifications:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case FETCH_SCHEDULED_NOTIFICATIONS:
        return {
          ...state,
          loading:true
        };
      case FETCH_SCHEDULED_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          scheduled:action.payload,
          loading:false
        };
      case FETCH_SCHEDULED_NOTIFICATIONS_FAILED:
        return {
          ...state,
          scheduled:null,
          loading:false
        };
      case FETCH_CAMPAIGNS:
        return {
          ...state,
          campaignsLoading: state.campaigns === null
        };
      case FETCH_CAMPAIGNS_SUCCESS:
        return {
          ...state,
          campaigns: action.payload,
          campaignsLoading: false
        };
      case FETCH_CAMPAIGNS_FAILED:
        return {
          ...state,
          campaignsLoading: false,
          error: { flag: true, msg: action.payload }
        };
      default:
        return state;
    }
  };
